function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(param, param1) {
    var font = param.font, readingDirection = param1.readingDirection;
    return {
        wrapper: {
            base: _objectSpread({
                width: '100%',
                boxSizing: 'border-box',
                fontFamily: font.base.family,
                fontSize: font.base.size.xxs,
                fontWeight: font.base.weight.regular,
                display: 'flex',
                flexDirection: 'column-reverse'
            }, readingDirection),
            showOverhang: {
                padding: '0 18px'
            }
        },
        sliderWrapper: {
            base: {
                position: 'relative',
                padding: '0 6px'
            },
            insetControls: {
                padding: 0
            }
        }
    };
};
var useStyle = function(param) {
    var isRtl = param.isRtl, showOverhang = param.showOverhang, insetControls = param.insetControls;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            wrapper: {},
            sliderWrapper: {}
        };
    }
    var wrapper = builtStyle.wrapper, sliderWrapper = builtStyle.sliderWrapper;
    return {
        wrapper: _objectSpread({}, wrapper.base, showOverhang && wrapper.showOverhang),
        sliderWrapper: _objectSpread({}, sliderWrapper.base, insetControls && sliderWrapper.insetControls)
    };
};
export default useStyle;
